var map = {
	"./category.vue": [
		"a382",
		"chunk-22212a6c"
	],
	"./group.vue": [
		"6159",
		"chunk-73558e3d"
	],
	"./index.vue": [
		"70ac",
		"chunk-337795ef"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "836b";
module.exports = webpackAsyncContext;